"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareBehaviorWeekQuery = void 0;
const prepareBehaviorWeekQuery = (queryArgs) => {
    let query = "query {";
    queryArgs.forEach(({ periodId, week }, idx) => {
        query += `
    week${idx}: progressCollection(subscriptionId: ${periodId}, day: null, week: ${week}) {
      id
      day
      date
    
      didLesson
      trained
      drankWater
      supplemented
      ateAsRecommended
    
      lessonOrdinalNumber
      lessonTitle
  }
`;
    });
    query += "}";
    return query;
};
exports.prepareBehaviorWeekQuery = prepareBehaviorWeekQuery;
//# sourceMappingURL=prepareQueryForBehaviourWeeks.js.map